/**
 * useFaceAnimation Hook
 *
 * Custom hook for managing face animations and effects.
 * Handles animation selection, timing, and visibility states.
 * Updated with extreme animations for client review.
 */
import { useState } from "react";

// Animation effects available for face appearances
const faceAnimationEffects = [
  {
    name: "specialFaceEntrance",
    duration: "1.8s",
    timing: "ease-out",
  },
  {
    name: "explosionEntrance",
    duration: "1.7s",
    timing: "ease-out",
  },
  {
    name: "shadowPulse",
    duration: "1.5s",
    timing: "ease-out",
  },
  {
    name: "bounceUp",
    duration: "1.6s",
    timing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  },
  {
    name: "bubblePopBounce",
    duration: "2.2s",
    timing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  },
  {
    name: "stoneSkipping",
    duration: "2.6s",
    timing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  {
    name: "stringPuppet",
    duration: "2.5s",
    timing: "cubic-bezier(0.215, 0.610, 0.355, 1.000)",
  },
];

const useFaceAnimation = () => {
  // State variables for face appearance control
  const [initialLoad, setInitialLoad] = useState(true);
  const [showSpecialEffect, setShowSpecialEffect] = useState(false);
  const [facesReady, setFacesReady] = useState(false);
  const [carouselReady, setCarouselReady] = useState(false);
  const [pageReady, setPageReady] = useState(false);
  const [showFaces, setShowFaces] = useState(false);
  const [selectedEffect, setSelectedEffect] = useState(null);

  // Function to get a random animation effect
  const getRandomFaceEffect = () => {
    const randomIndex = Math.floor(Math.random() * faceAnimationEffects.length);
    return faceAnimationEffects[randomIndex];
  };

  return {
    initialLoad,
    setInitialLoad,
    showSpecialEffect,
    setShowSpecialEffect,
    facesReady,
    setFacesReady,
    carouselReady,
    setCarouselReady,
    pageReady,
    setPageReady,
    showFaces,
    setShowFaces,
    selectedEffect,
    setSelectedEffect,
    getRandomFaceEffect,
    faceAnimationEffects,
  };
};

export default useFaceAnimation;
